import Link from "next/link";

import type { NavigationMenuNestedLeaf } from "@/components/header/navigationQuery.types";
import { ExternalLinkIcon } from "@/components/icons/externalLink.icon";

import { appendQueryString } from "@/utils/url.util";

import { SiteHeaderNavAnimatedUnderline } from "./siteHeaderNavAnimatedLink.component";

export const SiteHeaderMegaMenuLink = ({
  item,
}: SiteHeaderMegaMenuLinkProps) => {
  if (!item.link?.url) return null;
  const opensInNewTab = Boolean(item.link.openInNewTab);

  return (
    <li data-testid="site-header-mega-menu-list-item">
      <Link
        href={
          appendQueryString(item.link.url, item.link.queryString) ??
          item.link.url
        }
        target={opensInNewTab ? "_blank" : undefined}
        rel={opensInNewTab ? "noopener noreferrer" : undefined}
        data-testid="site-header-mega-menu-link"
        className="group text-promo-black relative py-4 font-bold tracking-wider">
        {item.label}
        {opensInNewTab ? (
          <ExternalLinkIcon
            width={14}
            height={14}
            className="ml-1 inline-block align-middle"
            data-testid="site-header-mega-menu-external-icon"
          />
        ) : null}
        <SiteHeaderNavAnimatedUnderline />
      </Link>
    </li>
  );
};

export type SiteHeaderMegaMenuLinkProps = {
  item: NavigationMenuNestedLeaf;
};
